import React from "react";
import './TicketRowDetail.scss'

export function TicketRowDetail({ date, isSelected }) {
    //console.log("TicketRowDetail")
    const details = {};
    if (date.current && date.hours[0].tickets) {
        date.hours[0].tickets.forEach(ticket => {
            if (!details[ticket.categoryId]) {
                details[ticket.categoryId] = {
                    items: [],
                    category: date.hours[0].widget.categories.find(category => category.id === ticket.categoryId)
                };
            }
            const prices = date.hours[0].widget.pricing.filter(price => price.categoryId === ticket.categoryId);
            if(prices.length > 0){
                details[ticket.categoryId].items.push({
                    ...ticket,
                    price: !ticket.formulaCode ? prices[0] : prices.find(price => price.formulaCode === ticket.selectedFormula.formulaCode)
                });
            }
        });
    }

    let recap = {};
    Object.keys(details).forEach(categoryId => {
        if (!recap[categoryId]) {
            recap[categoryId] = {};
        }
        details[categoryId].items.forEach(item => {
            if (item.price.formulaCode && !recap[categoryId][item.price.formulaCode]) {
                recap[categoryId][item.price.formulaCode] = {
                    items: [],
                    label: item.price.label
                };
            }
            recap[categoryId][item.price.formulaCode].items.push(item);
        })
    });
    let filteredTicket = date.hours[0].tickets.filter(ticket => {
        return ticket.hour.widget.startHour === date.hours[0].at
    })
    return (
        <>
            <span>{date.label} ({filteredTicket.length})</span>
            {!isSelected && Object.keys(details).map(key => (
                <div key={key} className={"TicketsTable-detail"}>
                    <span className={"TicketsTable-detail-categoryColor"} style={{
                        backgroundColor: details[key].category.color,
                        marginRight: 10
                    }}/>
                    <span className={"TicketsTable-detail-categoryName"}>{details[key].category.name}</span>
                    <span className={"TicketsTable-detail-count"}>({details[key].items.length})</span>
                    <div className={"TicketsTable-detail-formules"}>
                        {Object.keys(recap[key]).map(formulaCode => {
                            const seats = recap[key][formulaCode].items.filter(item => item.seatReference).map(item => item.seatReference);
                            return (
                                <div key={formulaCode}>
                                    <span>{recap[key][formulaCode].label}</span>
                                    {seats.length > 0
                                        ? <span style={{color: details[key].category.color}}> : {seats.join(', ')}</span>
                                        : ''
                                    }
                                </div>
                            )
                        })}
                    </div>
                </div>
            ))}
        </>
    );
}